<template>
  <a-modal
    :visible="isShowingTrackerModal"
    :title="'Link Tracker To Booking #' + booking.id"
    :confirm-loading="addingTracker"
    @ok="submitAddTracker"
    @cancel="$emit('modal-cancelled')"
  >
    <form @submit.prevent="submitAddTracker">
      <div class="form-group">
        <label class="h6" for="eroad-where-device-id-input">Tracker ID</label>
        <input
          ref="eroadWhereDeviceId"
          v-model="form.eroadWhereDeviceId"
          class="form-control"
          name="eroadWhereDeviceId"
          id="eroad-where-device-id-input"
          type="number"
          v-validate="'required|length:6|numeric'"
          @keyup.enter="submitAddTracker"
          placeholder="6 Digit Tracker Number"
          value=""
        />
        <div v-show="errors.has('eroadWhereDeviceId')">
          Please enter a 6-digit tracker number
        </div>
      </div>

      <br/>

      <div
        v-if="!booking.deliveryLocation.email"
        class="form-group"
      >
        <div>
          <p>This customer doesn't have an email address to receive tracking updates, would you like to add one?</p>
        </div>
        <label class="h6" for="email-input">Email</label>
        <input
          v-model="form.email"
          :class="['form-control', { 'is-invalid': errors.has('email') }]"
          name="email"
          id="email-input"
          type="text"
          v-validate="'email'"
          placeholder="john@freighthub.nz"
          value=""
        />
        <div v-show="errors.has('email')" class="invalid-feedback">
          Please enter a valid email
        </div>
      </div>
    </form>
  </a-modal>
</template>

<script>
import Modal from "../utils/Modal";

export default {
  name: "AddTrackerModal",
  components: {
    Modal
  },
  props: ['booking', 'isShowingTrackerModal'],
  emits: ['modal-cancelled', 'modal-submitted'],
  $_veeValidate: {
    validator: 'new'
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.eroadWhereDeviceId.focus();
    });
  },
  data() {
    return {
      form: {
        eroadWhereDeviceId: '',
        email: '',
        bookingId: this.booking.id
      },
      addingTracker: false
    }
  },
  methods: {
    submitAddTracker() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.addingTracker = true;
          axios
            .post("/send-freight/tracker/link", this.form)
            .then((res) => {
              this.$swal({
                title: "Tracker linked!",
                type: "success",
              });
              this.$emit('modal-submitted');
              this.addingTracker = false;
              this.$store.dispatch("loadBookings");
            })
            .catch((err) => {
              if (err.response.data.errors.eroadWhereDeviceId[0] !== 'undefined') {
                this.$swal({
                  title: err.response.data.errors.eroadWhereDeviceId[0],
                  type: "error",
                });
              } else {
                this.$swal({
                  title: "Please try again or contact us",
                  type: "error",
                });
              }
              this.addingTracker = false;
            });
        }
      });
    },
  }
}
</script>

<style scoped>

</style>